import React from 'react';

import styles from '../../utils/styles';

import './icon.scss';

export interface IconProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  reverseX?: boolean;
  reverseY?: boolean;
  fill?: string;
  svg?: Function;
}

const Icon: React.FC<IconProps> = ({
  className,
  width = 24,
  height = 24,
  color,
  reverseX = false,
  reverseY = false,
  fill = 'currentColor',
  svg = () => {},
}) => {
  const iconClassName = `${styles(`icon`)} ${className || ''}`;
  const reversed = reverseX || reverseY ? `scale(${reverseX ? -1 : 1}, ${reverseY ? -1 : 1})` : undefined;

  return (
    <i className={iconClassName} style={{ color, transform: reversed }}>
      {svg({
        fill,
        width,
        height,
      })}
    </i>
  );
};

export default Icon;
